module.exports = require("./ko-KP.js");